import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  item: NewsItem;
  variant?: "grid" | "list" | "compact";
}

export default function NewsCard({ item, variant = "grid" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/detail/news/${item.id}`}
        className="group flex gap-3 rounded-lg p-2 transition-colors hover:bg-background-100 cursor-pointer"
      >
        <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 韩剧资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0">
          <h4 className="line-clamp-2 text-sm font-500 text-foreground-900 group-hover:text-primary-600">
            {item.title}
          </h4>
          <p className="mt-1 text-xs text-foreground-500">{item.date}</p>
        </div>
      </Link>
    );
  }

  if (variant === "list") {
    return (
      <Link
        to={`/detail/news/${item.id}`}
        className="group flex flex-col gap-4 rounded-xl border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-primary-200 sm:flex-row cursor-pointer"
      >
        <div className="h-40 w-full shrink-0 overflow-hidden rounded-lg bg-background-200 sm:h-28 sm:w-44">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 韩剧资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center gap-2">
            <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
              {item.tag}
            </span>
            <span className="text-xs text-foreground-500">{item.date}</span>
          </div>
          <h3 className="mt-2 line-clamp-1 font-heading text-base font-600 text-foreground-950 group-hover:text-primary-600">
            {item.title}
          </h3>
          <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {item.summary}
          </p>
          <span className="mt-auto hidden pt-2 text-xs text-foreground-500 sm:block">
            {item.author}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200 cursor-pointer"
    >
      <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 韩剧资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
            {item.tag}
          </span>
          <span className="text-xs text-foreground-500">{item.date}</span>
        </div>
        <h3 className="mt-2.5 line-clamp-2 font-heading text-base font-600 leading-snug text-foreground-950 group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-auto flex items-center gap-1 pt-3 text-xs text-foreground-500">
          <i className="ri-edit-line text-sm"></i>
          {item.author}
        </div>
      </div>
    </Link>
  );
}